/* eslint-disable quote-props */
/* eslint-disable key-spacing */

import { registerSound } from './sound'

export const SOUNDS = {
  bone: [
    registerSound('items/bone_1'),
    registerSound('items/bone_2'),
    registerSound('items/bone_3'),
    registerSound('items/bone_4'),
  ],
  cloth: [
    registerSound('items/cloth_1'),
    registerSound('items/cloth_2'),
    registerSound('items/cloth_3'),
    registerSound('items/cloth_4'),
  ],
  gun: [
    registerSound('items/gun_1'),
    registerSound('items/gun_2'),
    registerSound('items/gun_3'),
    registerSound('items/gun_4'),
  ],
  leather: [
    registerSound('items/leather_1'),
    registerSound('items/leather_2'),
    registerSound('items/leather_3'),
    registerSound('items/leather_4'),
  ],
  metal: [
    registerSound('items/metal_1'),
    registerSound('items/metal_2'),
    registerSound('items/metal_3'),
    registerSound('items/metal_4'),
    registerSound('items/metal_5'),
    registerSound('items/metal_6'),
    registerSound('items/metal_7'),
    registerSound('items/metal_8'),
  ],
  metal_hollow: [
    registerSound('items/metal_hollow_1'),
    registerSound('items/metal_hollow_2'),
    registerSound('items/metal_hollow_3'),
    registerSound('items/metal_hollow_4'),
  ],
  metal_sheet: [
    registerSound('items/metal_sheet_1'),
    registerSound('items/metal_sheet_2'),
    registerSound('items/metal_sheet_3'),
    registerSound('items/metal_sheet_4'),
  ],
  metal_wood: [
    registerSound('items/metal_wood_1'),
    registerSound('items/metal_wood_2'),
    registerSound('items/metal_wood_3'),
    registerSound('items/metal_wood_4'),
  ],
  plastic: [
    registerSound('items/plastic_1'),
    registerSound('items/plastic_2'),
    registerSound('items/plastic_3'),
    registerSound('items/plastic_4'),
  ],
  rubber: [
    registerSound('items/rubber_1'),
    registerSound('items/rubber_2'),
    registerSound('items/rubber_3'),
    registerSound('items/rubber_4'),
  ],
  stone: [
    registerSound('items/stone_1'),
    registerSound('items/stone_2'),
    registerSound('items/stone_3'),
    registerSound('items/stone_4'),
  ],
  wood: [
    registerSound('items/wood_1'),
    registerSound('items/wood_2'),
    registerSound('items/wood_3'),
    registerSound('items/wood_4'),
    registerSound('items/wood_5'),
    registerSound('items/wood_6'),
    registerSound('items/wood_7'),
    registerSound('items/wood_8'),
  ],
}

export const TYPE_SOUNDS = {
  'TShirt':                   ['cloth'],
  'Roadsign Jacket':          ['cloth', 'leather'],
  'Boots':                    ['rubber'],
  'Roadsign Kilt':            ['metal_sheet'],
  'Double Barrel Shotgun':    ['gun'],
  'Hoodie':                   ['cloth'],
  'Pump Shotgun':             ['gun'],
  'Stone Hatchet':            ['stone'],
  'Pants':                    ['cloth', 'leather'],
  'Rocket Launcher':          ['gun'],
  'Revolver':                 ['gun'],
  'Semi Auto Rifle':          ['gun'],
  'Sheet Metal Door':         ['metal'],
  'Metal Facemask':           ['metal'],
  'Hatchet':                  ['metal_wood'],
  'Mp5':                      ['gun'],
  'AK47u':                    ['gun'],
  'Large Wooden Box':         ['wood'],
  'Burlap Trousers':          ['cloth'],
  'Guitar':                   ['wood'],
  'Rifle Helmet':             ['metal_hollow'],
  'Metal Torso Plate':        ['metal_hollow'],
  'Shorts':                   ['cloth'],
  'Burlap Gloves':            ['cloth'],
  'Bolt Rifle':               ['gun'],
  'Salvaged Sword':           ['metal_sheet'],
  'Armored Metal Door':       ['metal_sheet'],
  'Longsword':                ['metal_sheet'],
  'Bone Club':                ['bone'],
  'SMG':                      ['gun'],
  'Wooden Door':              ['wood'],
  'Semi Auto Pistol':         ['gun'],
  'Sleeping Bag':             ['cloth'],
  'Wooden Box':               ['wood'],
  'Long TShirt':              ['cloth'],
  'Hide Pants':               ['leather'],
  'Snow Jacket':              ['leather'],
  'Burlap Shirt':             ['cloth'],
  'Balaclava':                ['cloth'],
  'Rock':                     ['stone'],
  'Hammer':                   ['wood'],
  'Stone Pickaxe':            ['stone'],
  'Bone Knife':               ['bone'],
  'Grenade':                  ['metal'],
  'Crossbow':                 ['gun'],
  'Waterpipe Shotgun':        ['gun'],
  'Coffeecan Helmet':         ['metal_sheet'],
  'Reactive Sign':            ['metal'],
  'Burlap Shoes':             ['cloth'],
  'Bucket Helmet':            ['plastic'],
  'Collared Shirt':           ['cloth'],
  'Cap':                      ['cloth'],
  'Bandana':                  ['cloth'],
  'Hide Halterneck':          ['leather'],
  "Miner's Hat":              ['leather'],
  'Satchel Explosives':       ['leather'],
  'Beenie':                   ['cloth'],
  'Salvaged Icepick':         ['metal_wood'],
  'Boonie':                   ['cloth'],
  'Thompson':                 ['gun'],
  'Burlap Headwrap':          ['cloth'],
  'Hide Poncho':              ['leather'],
  'Jacket':                   ['leather'],
  'Concrete Barricade':       ['stone'],
  'Hide Skirt':               ['leather'],
  'Deer Skull Mask':          ['bone'],
  'Sandbag Barricade':        ['plastic'],
  'Tank Top':                 ['cloth'],
}

export const itemPickupSound = (type, volume = 0.5) => {
  const categories = TYPE_SOUNDS[type] || ['plastic']
  const category = categories[Math.floor(Math.random() * categories.length)]

  const sounds = SOUNDS[category]
  const sound = sounds[Math.floor(Math.random() * sounds.length)]

  const instance = sound.play()
  sound.volume(volume, instance)
}
